// [PLACEHOLDER] Facebook URL still "#" until supplied.
const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/textmefood/", bg: "linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
    path: "M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 4.9a4.9 4.9 0 100 9.8 4.9 4.9 0 000-9.8zm0 8.1a3.2 3.2 0 110-6.4 3.2 3.2 0 010 6.4zm5.1-8.3a1.1 1.1 0 100-2.3 1.1 1.1 0 000 2.3z" },
  { name: "Facebook", href: "#", bg: "#1877F2",
    path: "M13.5 21.9v-8.1h2.7l.4-3.2h-3.1V8.6c0-.9.3-1.5 1.6-1.5h1.7V4.2c-.3 0-1.3-.1-2.5-.1-2.4 0-4.1 1.5-4.1 4.2v2.3H7.5v3.2h2.7v8.1h3.3z" },
  { name: "X", href: "https://x.com/TextMeFood", bg: "#000000",
    path: "M17.8 3h3.1l-6.8 7.8L22 21h-6.3l-4.9-6.4L5.2 21H2.1l7.3-8.3L1.8 3h6.4l4.4 5.8L17.8 3zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5z" },
  { name: "YouTube", href: "https://www.youtube.com/@TestMeFood", bg: "#FF0000",
    path: "M21.6 7.2a2.5 2.5 0 00-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.5 2.5 0 002.4 7.2C2 8.8 2 12 2 12s0 3.2.4 4.8a2.5 2.5 0 001.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.5 2.5 0 001.8-1.8c.4-1.6.4-4.8.4-4.8s0-3.2-.4-4.8zM10 15V9l5.2 3L10 15z" },
];

export function SocialLinks() {
  return (
    <div className="flex flex-col items-center gap-2" data-testid="footer-social-links">
      <span className="text-[10px] uppercase tracking-widest text-emerald-300/70">Follow TMF</span>
      <div className="flex items-center gap-3">
        {SOCIALS.map((s) => (
          <a key={s.name} href={s.href} target="_blank" rel="noreferrer" aria-label={s.name} title={s.name}
            data-testid={`social-${s.name.toLowerCase()}`}
            style={{ background: s.bg }}
            className="w-10 h-10 rounded-full flex items-center justify-center shadow-md ring-2 ring-white/10 hover:ring-white/60 hover:-translate-y-1 hover:scale-110 transition-transform duration-200">
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white"><path d={s.path} /></svg>
          </a>
        ))}
      </div>
    </div>
  );
}
